module.exports = "/_next/static/images/EmbraceGoodData-5338b3d893ceeee77960eefbff3c01c9.webp";